import React, { useState } from "react";
import useForm from "react-hook-form";
import Helmet from "react-helmet";
import Layout from "../layout";
import config from "../../data/SiteConfig";
import Contact from "../components/Contact";

const ContactPage = () => (
  <Layout>
    <main>
      <Helmet title={`تواصل معنا | ${config.siteTitle}`} />

      <Contact />
    </main>
  </Layout>
);
export default ContactPage;
